<template lang="pug">
#detail.comAll(v-dragDiv,v-show="!actionData.isMini")
  .title.moveDragDiv
    span {{actionData.cnName}}
    i.el-icon-minus.minibtn(title='最小化' @click='miniCom')
    i.el-icon-close(@click='closeAdd')
  .nav
    notationDetail(ref="notationDetail" :questionId="actionData.questionId" @startScreenShot="startScreenShot" type='dwg')
</template>

<script>
import notationDetail from "@/CommonDP/mongeView/question/notationDetail.vue";
import mongeCommon from "@/CommonDP/mongeView/common/mongeCommon";
export default {
  components: { notationDetail },
  props: {
    actionData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  methods: {
    miniCom() {
      this.$emit("closeCom", 'detail', true);
    },
    closeAdd() {
      this.$emit("closeCom", 'detail', false);
    },
    async startScreenShot (call) {
      const cutpic = await mongeCommon.startScreenShot("dwg");
      call.callback(cutpic);
    }
  }
};
</script>

<style lang="scss" scoped src="@/CommonDP/mongeView/common/common.scss" ></style>
<style lang="scss" scoped>
#detail{
  position: fixed;
  top: 35px;
  right: 330px;
  width: 360px;
  height: calc(100% - 90px);
  max-height: 870px;
  .nav{
    height: calc(100% - 50px);
    overflow-y: auto;
  }
}
</style>
